module.exports = __webpack_public_path__ + "static/media/06-aei.56bf813f.png";